import { BootstrapData } from '../api/types';

/**
 * Судьба резервов (released/swept) живёт в D1 (`bootstrap.reserve_state`,
 * миграция 0010) и одинакова на всех устройствах. Здесь — только выборка
 * из данных; мутации — `BudgetContext.putReserve/sweepReserve` (через очередь).
 */

export interface ReserveSets {
  released: Set<string>;
  swept: Set<string>;
}

export function reserveSets(data: BootstrapData | null, monthKey: string): ReserveSets {
  const released = new Set<string>();
  const swept = new Set<string>();
  for (const r of data?.reserve_state ?? []) {
    if (r.month !== monthKey) continue;
    if (r.state === 'released') released.add(r.category);
    else if (r.state === 'swept') swept.add(r.category);
  }
  return { released, swept };
}

// ---------------------------------------------------------------------------
// Легаси-localStorage (до 0010) — читается только бэкфиллом миграции состояния.
// ---------------------------------------------------------------------------

export const LEGACY_RESERVE_KEY = 'reserve_state';

export interface LegacyReserveStore {
  released: Record<string, string[]>;
  swept: Record<string, string[]>;
}

export function readLegacyReserveStore(): LegacyReserveStore {
  try {
    const raw = localStorage.getItem(LEGACY_RESERVE_KEY);
    if (!raw) return { released: {}, swept: {} };
    const p = JSON.parse(raw);
    return { released: p.released ?? {}, swept: p.swept ?? {} };
  } catch {
    return { released: {}, swept: {} };
  }
}
